import styled from 'styled-components'
import {Link} from 'react-router-dom'

export const LINK = styled(Link)`
  text-decoration: none;
`

export const Nav = styled.nav`
  background-color: ${props => (props.dark ? '#212121' : 'white')};
  padding: 35px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  width: 100%;
  position: sticky;
  scroll-behavior: smooth;
  top: 0;
`

export const Logo = styled.img`
  width: 120px;
`

export const IconsCardSm = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;

  @media (min-width: 768px){
    display: none;
  }
`

export const IconsCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 30px;

  @media (max-width: 768px){
    display: none;
  }
`

export const Button = styled.button`
  outline: none;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 23px;
  color: ${props => props.dark && 'white'};
`

export const ProfileImg = styled.img`
  width: 30px;
`

export const Logout = styled.button`
  border: 1px solid ${props => (props.dark ? 'white' : '#3b82f6')};
  padding: 5px 12px;
  color: ${props => (props.dark ? 'white' : '#3b82f6')};
  font-size: 13px;
  background: transparent;
  outline: none;
  cursor: pointer;
`

export const LogoutCard = styled.div`
  width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  padding: 40px;
  background-color: ${props => (props.dark ? '#212121' : 'white')};
  border: none;
  border-radius: 5px;
`

export const LOText = styled.p`
  color: ${props => (props.dark ? 'white' : '#212121')};
  font-size: 14px;
  text-align: center;
`

export const LOBtns = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;
`

export const LOButton = styled.button`
  border: ${props => (props.logout ? 'none' : '1px solid lightgray')};
  border-radius: 3px;
  font-size: 13px;
  padding: 7px 14px;
  color: ${props => (props.dark ? 'gray' : 'lightgray')};
  background: ${props => (props.logout ? '#3b82f6' : 'transparent')};
`

export const Ul = styled.ul`
  display: grid;
  padding: 0px;
  margin-top: 45vw;
  background-color: ${props => (props.dark ? '#212121' : 'white')};
`

export const Li = styled(Link)`
  text-decoration: none;
  font-weight: 500;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  padding: 13px 0px 13px 22px;
  background-color: ${props => {
    if (props.active === 'hightLight') {
      return props.dark ? '#616e7c' : '#e2e8f0'
    }
    return ''
  }};
`

export const List = styled.p`
  color: ${props => (props.dark ? '#ffffff' : '#212121')};
  font-size: 15px;
  margin: 0px;
`

export const Menu = styled.div`
  height: 100vh;
  width: 100%;
  padding: 20px 0px;
  display: flex;
  flex-direction: column;
  background-color: ${props => (props.dark ? '#212121' : 'white')};
`
